import { supabase } from '../lib/supabase'

/**
 * Guía con IA (OpenAI) para quien reporta un incidente de seguridad
 * (Edge Function `incident-first-steps`).
 * @namespace incidentAssistantService
 */
const incidentAssistantService = {
  functionName: 'incident-first-steps',

  /**
   * Primeros pasos a seguir de inmediato para un reporte.
   * @param {Object} report
   * @param {string} report.description
   * @param {string} [report.category] - Etiqueta del tipo de incidente.
   * @param {string} [report.severity]
   * @param {string} [report.detectionSource]
   * @param {boolean} [report.personalData]
   * @param {string[]} [report.assets] - Nombres de activos involucrados.
   * @returns {Promise<{success: boolean, data: {summary: string,
   *   steps: Array<{title: string, detail: string, urgent: boolean}>,
   *   dont: string[]}|null, error: string|undefined}>}
   */
  async firstSteps(report) {
    try {
      const { data, error } = await supabase.functions.invoke(
        this.functionName,
        { body: { report } }
      )
      if (error) {
        // El cuerpo del error trae el motivo legible de la función.
        const detail = await error.context?.json?.().catch(() => null)
        throw new Error(detail?.error || error.message)
      }
      if (data?.error) throw new Error(data.error)
      return { success: true, data: data.result }
    } catch (error) {
      console.error('Error en primeros pasos de incidente:', error)
      return { success: false, data: null, error: error.message }
    }
  },
}

export default incidentAssistantService
